// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"2731aed0","457":"b1e7b373","876":"b16a53bb"}[chunkId] + ".chunk.js";
};